/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { combineReducers } from 'redux';
import { sessionExtension } from './components/common/SessionModal/reducers';
import addons from './pages/Addons/reducer';
import contactInfo from './pages/ContactInfo/reducer';
import plansReferenceData from './utils/plansReference/reducer';
import cartDetails from './services/Cart/reducer';
import creditCheckDetails from './pages/CreditCheck/reducer';
import edgeIneligible from './pages/CreditcheckEdgeIneligible/reducer';
import registrationInfo from './pages/Registration/reducer';
import { progressSteps, processSteps } from './utils/ProgressStep/reducer';
import { progressStepsMV, processStepsMV } from './utils/ProgressStepMV/reducer';
import loaderReducer from './components/common/Loader/reducer';
import { notification } from './components/common/NotificationBar/reducer';
import deviceSetup from './pages/DeviceSetup/reducer';
import shippingInfo from './pages/ShippingInfo/reducer';
import cradleReducer from './pages/CradleService/reducer';
// eslint-disable-next-line import/no-duplicates
import termsAndConditions from './pages/ReviewOrderPage/reducer';
// eslint-disable-next-line import/no-duplicates
// import tos from './pages/ReviewOrderPage/reducer';
import appointmentSchedule from './pages/AppointmentSchedule/reducer';
import resumecartTemplate from './pages/ResumeCart/reducer';
import paymentInfo from './pages/PaymentInfo/reducer';
import orderConfirmation from './pages/OrderConfirmation/reducer';
import { NBS } from './pages/Cart/reducer';
import d2dEidQA from './pages/EidQuestions/reducer';
import creditDownPayment from './pages/CreditDownPayment/reducer';
// import routerUpgrade from './pages/EUP/reducer';
import cBandPlans from './pages/CBandPlans/reducer';
import videoChat from './components/common/VideoChat/reducer';
import SessionValues from './pages/Common/SessionValues/reducer';
import tagging from './pages/Common/Tagging.js/reducer';
import techCBand from './pages/Tech/reducer';
import testForms from './pages/Test/reducer';
import eagleCPC from './pages/CPC/reducer';
import whwTech from './pages/whwTech/reducer';
import moversReducer from './pages/Movers/@Redux/Reducer/MoversReducer';
import getCheckOutDetails from './pages/FuncComp/reducer';
import baseTemplate from './pages/ExpressCart/reducer';
import Redirection from './pages/Redirection/reducer';

import contactDetailsReducer from './pages/ContactInformation/@Redux/Reducer/contactInfo.reducer';
import typeAheadAddressReducer from './pages/ContactInformation/@Redux/Reducer/typeAheadAddress.reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
const allReducers = {
  plansReferenceData,
  processSteps,
  progressSteps,
  sessionExtension,
  addons,
  cartDetails,
  contactInfo,
  contactDetails: contactDetailsReducer,
  typeAheadInfo: typeAheadAddressReducer,
  creditCheckDetails,
  registrationInfo,
  loader: loaderReducer,
  notification,
  deviceSetup,
  shippingInfo,
  termsAndConditions,
  // tos,
  appointmentSchedule,
  resumecartTemplate,
  paymentInfo,
  orderConfirmation,
  NBS,
  d2dEidQA,
  edgeIneligible,
  creditDownPayment,
  // routerUpgrade,
  cBandPlans,
  videoChat,
  tagging,
  SessionValues,
  techCBand,
  testForms,
  eagleCPC,
  whwTech,
  processStepsMV,
  progressStepsMV,
  moversReducer,
  getCheckOutDetails,
  baseTemplate,
  Redirection,
  cradleReducer,
};
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    currentView,
    ...allReducers,
    ...injectedReducers,
  });
  return rootReducer;
}
const currentView = (state = {}, action) => {
  switch (action && action.type) {
    case 'UPDATE_CURRENT_VIEW': {
      return { ...action.response };
    }
    case 'UPDATE_CURRENT_VIEW_MV': {
      return { ...action.response };
    }
    default:
      return state;
  }
};
